import Vue from 'vue'
import Vuex from 'vuex'

import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'

Vue.use(Vuex);

var store = {
    state: {
        _id: false,
        id: false,
        pages: [],
        ads: [],
        terms: '',
        amount: 10,
        response_id: '',
        pay: {
            amount: '10.00'
        },
        offers: [],
        survey: false,
        competitions: false,
        selectedCategory: false,
        TsCs: '',
        user: false,
        auth: false,
        name: '',
        customerNo: '',
        sendSMS: true,
        sendEMAIL: true,
        phone: false,
        loyalty_id: false,
        loyaltyId: false,
        iss: false,
        copper: true,
        clientCampaigns: [],
        host: '',
        client_id: '',
        headerBack: '',
        headerPlain: '',
        backgroundColor: '',
        fontColor: '',
        btnColor: '',
        btnFontColor: '',
        infoFontColor: '',
        title: '',
        siteTitle: '',
        favicon: '',
        memberShipPrice: 0,
        joinPage: '',
        twoele: '',
        loyal1: '',
        loyal2: '',
        welcome: '',
        man: '',
        avatar: false,
        contactUs: '',
        joinWords: '',
        appleFav: '',
        catWords: '',
        adCats: false,
        menu: [],
        selectedCat: true,
        comps: [],
        entries: [],
        loyaltyCampaign_id: false,
        referWords: '',
        terms_id: '',
        referCampaign_id: '',
        referCampaignQty: 0,
        campaign_id: '',
        takeSurvey: [],
        homeBanner: {},
        btnImage: false,
        score: false,
        scores: [],
        //testURL: 'letsreset.club'
        testURL: 'dev.memberstar.club'
    },
    actions: {
        addHead ({ state, commit }, data ) {
            if ( document.head.querySelector('#'+data.id) ) return;
            var element = document.createElement(data.t);
                Object.keys(data).filter(k => k != 't').forEach(k => element.setAttribute(k,data[k]));
                document.head.appendChild(element);
        },
        wsAction ({ state, commit, dispatch }, msg ) {
            //console.log('wsAction',msg);
            switch ( msg.t ) {
                case 'noSite':
                    commit('setPages',['no-site']);
                    break;
                case 'setClient': 
                    var client = msg.data.client;
                    //console.log('setClient client',client);
                    Object.keys(client).forEach(k => {
                        k == '_id' && ( k = 'client_id', client[k] = client._id );
                        commit('setValue',{ k, v: client[k] });
                    });
                    document.querySelector('title').innerText = client.siteTitle;
                    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    var apple = document.querySelector("link[rel*='apple-touch-icon']") || document.createElement('link');
                    apple.rel = 'apple-touch-icon';
                    apple.sizes = '180x180';
                    //console.log('client.appleFav',client.appleFav);
                    apple.href = client.appleFav;
                    document.querySelector('head').appendChild(apple);
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = client.favicon;
                    document.querySelector('head').appendChild(link);
                    Alert.setColors(client);
                    break;
                case 'setAds':
                    console.log('setAds',msg.data.ads);
                    //commit('setValue',{ k: 'pages', v: ['home','survey' ]});
                    //commit('setValue',{ k: 'ads', v: msg.data.ads });
                    break;
                case 'removeCustomer':
                    commit('clearAuth');
                    break;
                case 'setLoyalty':
                    commit('setAuth',{ _id: msg.data.loyalty_id, id: msg.data.loyaltyId });
                    break;
                    case 'saveLoyalty':
                        commit('setAuth',{ _id: msg.data._id, id: msg.data.id });
                        break;                    
                case 'startSurvey':
                    //commit('setSurvey',msg.data);
                    break;
                case 'updatePhone':
                    commit('setValue',{ k: 'name', v: msg.data.name });
                    commit('setValue',{ k: 'customer_id', v: msg.data.customer_id });
                    commit('setValue',{ k: 'phone', v: msg.data.phone });  
                    break;
                case 'setCustomer':
                    //console.log('setCustomer',msg.data);
                    msg.data.name && commit('setValue',{ k: 'name', v: msg.data.name })
                    msg.data.phone && commit('setValue',{ k: 'phone', v: msg.data.phone });
                    msg.data.email && commit('setValue',{ k: 'email', v: msg.data.email });
                    msg.data.customerNo && commit('setValue',{ k: 'customerNo', v: msg.data.customerNo });
                    msg.data.entries && commit('setValue',{ k: 'entries', v: msg.data.entries });
                    msg.data.avatar && commit('setValue',{ k: 'avatar', v: msg.data.avatar });
                    typeof msg.data.sendSMS != 'undefined' && commit('setValue',{ k: 'sendSMS', v: msg.data.sendSMS })
                    typeof msg.data.sendEMAIL != 'undefined' && commit('setValue',{ k: 'sendEMAIL', v: msg.data.sendEMAIL })
                    //console.log('setCustomer setPages',JSON.stringify(state.pages));
                    state.pages.indexOf('home') == -1 && commit('setPages',['home']);
                    dispatch('getScore');
                    break;
                case 'startCustomer':
                    commit('setValue',{ k: 'customerID', v: msg.data.customerID });
                    commit('setValue',{ k: 'customer_id', v: msg.data.customer_id });
                    commit('setValue',{ k: 'iss', v: msg.data.iss });
                    break;
                 case 'copperhouse':
                     var customer = msg.data.customer
                     if ( customer ) {
                         commit('setValue',{ k: 'copper', v: { phone: customer.phone, msisdn: customer.msisdn, name: customer.name, email: customer.email, _id: customer._id }});
                     }   

            }
            //console.log({ loyalty_id: localStorage.loyalty_id, loyaltyId: localStorage.loyaltyId })

        },
        getScore ({ state, commit }) {
            //console.log('action getScore',state.client_id == '5f69cbbb01e0610ab651e146');
            state.client_id == '5f69cbbb01e0610ab651e146' && WebSoc.SEND({ t: 'getScore', data: { client_id: state.client_id, customer_id: state.auth._id, customerId: state.auth.id }},resp => {
                //console.log('getScore',resp);
                typeof resp.score == 'number' && commit('setValue',{ k: 'score', v: resp.score });
            })            
        },
        getScores ({ state, commit }) {
            state.client_id == '5f69cbbb01e0610ab651e146' && WebSoc.SEND({ t: 'getScores', data: { client_id: state.client_id, customer_id: state.auth._id, customerId: state.auth.id }},resp => {
                //console.log('getScores',resp);
                Array.isArray(resp.scores) && commit('setValue',{ k: 'scores', v: resp.scores.reverse() });
            })               
        },
        getSurvey ({ state, commit },data) {
            WebSoc.SEND({ t: 'getSurvey', data },survey => {
                survey && commit('setSurvey',survey);
                location.href = 'http://'+location.host+'/'+data.campaign_id+'/'+data.iss+'/'+data.id;
            });
        },
        getTerms ({ state, commit }, data ) {
            console.log('getTerms data',data);
            if ( state.terms ) return;
            WebSoc.SEND({ t: 'getTsCs' },resp => {
                commit('saveTerms',resp.tscs);
                
            })
        },
        getOffers ({ state, commit }, campaign_id ) {
            console.log('getOffers ??');
            if ( state.offers ) return;
            WebSoc.SEND({ t: 'getOffers', data: { campaign_id } },offers => {
                commit('saveOffers',offers)
            })
        }
    },
    mutations: {
        clearAuth ( state ) {
            state.entries = [];
            state.comps = [];
            state.ads = [];
            state.offers = [];
            state.auth = false;
            state.loyalty_id = false;
            state.loyaltyId = false;
            state.pages = ['home','copper'];
            state.name = '';
            state.customerNo = '';
            try {
                localStorage.clear();
            } catch(e) {

            }
        },
        setValue ( state, { k, v }) {
            //console.log('setValue',{ k, v });
            state[k] = v;
        },
        setKeyValue ( state, { item, k, v }) {
            item[k] = v;
        },
        setItemKeyValue ( state,{ item, k, v }) {
            item[k] = v;
        },
        addEntry ( state, entry ) {
            entry.entered = true;
            state.entries.push(entry);
        },
        setAuth ( state, auth ) {
            //console.log('setAuth',auth);
            state.auth = auth;
            if ( !auth ) return;
            //console.log('setAuth auth._id',auth._id);
            //console.log('setAuth auth.id',auth.id);
            try {
                state._id = auth._id;
                state.id = auth.id;
                localStorage.loyalty_id = auth._id;
                localStorage.loyaltyId = auth.id;
            } catch(e) {

            }
            //setInterval(() => console.log({ loyalty_id: localStorage.loyalty_id, loyaltyId: localStorage.loyaltyId }),1000);
            store.mutations.setValue(state,{ k: 'auth', v: auth })
            auth.name && ( state.name = auth.name );
            auth.phone && ( state.phone = auth.phone );
            auth.email && ( state.email = auth.email );
        },
        setSurvey ( state, survey ) {
            survey.pages.forEach(p => p.date = Date.now());
            state.ads = survey.pages;
            console.log('setSurvey');
            state.pages = ['home','survey'];
        },
        setCompetitions ( state, competitions ) {

        },
        saveTerms ( state, terms ) {
            state.terms = terms;
        },
        saveOffers ( state, offers ) {
            console.log('saveOffers')
            state.offers = offers;
        },
        setPages ( state, pages ) {
            state.pages = pages;
        },
        pushPage ( state, page ) {
            //console.log('pushPage',page);
            if ( !page ) return;
            state.pages.indexOf(page) == -1 && state.pages.push(page);
        },
        popPage ( state, page ) {           
            setTimeout(() => {
                if ( page ) { var indexPage = state.pages.indexOf(page) }
                if ( page && indexPage == -1 ) return;
                if ( !page ) return console.log('must specify popPage')
                state.pages.splice(indexPage,1);
            },500)
        }
    }
}

export default new Vuex.Store(store);